import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow-x: hidden;
  width: 100%;
  background-color: rgba(54, 65, 82, 0.07) !important;
`;
